// extracted by mini-css-extract-plugin
module.exports = {"container":"BacktestChart_container__2v0jv","loader":"BacktestChart_loader__2uUQK","chartPlaceholder":"BacktestChart_chartPlaceholder__oBYx_"};